module.exports = __webpack_public_path__ + "static/media/icon-header-report.ce089a95.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Header/assets/icon-header-report.svg
// module id = 1512
// module chunks = 193